<template>
    <div style="padding:10px">
      <van-row>
        <van-col span="16">
            <van-grid :gutter="11" :column-num="1" clickable>
              <van-grid-item :text="$store.getters.getCari.aktif.unvan"/>
            </van-grid>
        </van-col>
        <van-col span="8">
            <van-grid :gutter="11" :column-num="1" clickable>
              <van-grid-item :text="$store.getters.getCari.aktif.bakiye+''+hesap.pb"/>
            </van-grid>    
        </van-col>
      </van-row>

      <van-grid :gutter="15" :column-num="3" clickable style="margin-top: 15px;">
        <van-grid-item icon="chart-trending-o" text="Ekstre" to="/cari/hareket" />
        <van-grid-item icon="bag-o" text="sepet" to="/sepet" :badge="this.$store.getters.getCari.aktif.success"/>        
        <van-grid-item icon="orders-o" text="Liste" to="/liste" :badge="this.$store.getters.getVirtual.proforma[this.$store.getters.getCari.aktif.kod].length"/>        
        <van-grid-item icon="balance-o" text="Tahsilat" to="/cari/tahsilat" />
        <van-grid-item icon="todo-list-o" text="Sipariş" to="/satis" />
        <van-grid-item icon="logistics" text="Ziyaret" to="/cari/ziyaret" />
        <!-- <van-grid-item icon="setting-o" text="Ayarlar" to="/" /> -->
      </van-grid>
      
    </div>
</template>

<script>
export default {
  components:{},
  data() {
    return {
      hesap :  this.$store.getters.getHesap,

    };
  },
  created (){},

  methods : {}
};
</script>


// WEBPACK FOOTER //
// src/views/caridetay.vue